import Locales from '../../common/modules/locales';

require('../../vendor/custom-event-polyfill.min');
require('../../vendor/array.find.polyfill');
require('../../vendor/mustache.min');

import EventsPageModel from './includes/model';
import EventsPageView from './includes/view';

class EventsPage {
    constructor() {
        this.model = new EventsPageModel();
        this.view = new EventsPageView();
        this.numberEventsDisplayed = 6;

        this.filters = {
            upcoming: {
                maxVisibleEvents: this.numberEventsDisplayed,
                location: 'US'
            },
            recent: {
                maxVisibleEvents: this.numberEventsDisplayed,
                location: 'US',
                category: 'All'
            }
        };

        this.init();
    }

    init() {
        this.render();
        this.addFilterChangeListener();
        this.addCategoryChangeListener();
        this.addMoreEventsListener();
        this.addEventClickListener();
    }

    render() {
        const mainEvent = this.model.getMainEvent();
        this.view.setHeaderDarkTheme();
        const upComingEvent = this.model.getUpcomingEvents(this.filters['upcoming']);

        if (this.isUserFromEurope()) {
            this.settingWebinarLocale('EU');
        }

        if (this.isUserFromNorthAmerica()) {
            this.settingWebinarLocale('US');
        }

        if (mainEvent && EventsPageModel.isFutureEvent(mainEvent)) {
            this.view.renderMainEventSection(mainEvent);
        }

        if (upComingEvent.length) {
            this.renderEvents('upcoming');
            this.view.$sectionUpcomingEvents.removeClass('isEmpty');
        }

        this.renderEvents('recent');
        this.view.hideLoader();
    }

    settingWebinarLocale(currentLocation) {
        this.setFilter(currentLocation, 'upcoming');
        this.setFilter(currentLocation, 'recent');
        const upComingEvent = this.model.getUpcomingEvents(this.filters['upcoming']);
        const recentEvent = this.model.getRecentEvents(this.filters['recent']);
        if (!upComingEvent.length) {
            this.setFilter('All', 'upcoming');
        }
        if (!recentEvent.length) {
            this.setFilter('All', 'recent');
        }
    }

    isUserFromEurope() {
        return Locales.checkEurope(this.model.user.country);
    }

    isUserFromNorthAmerica() {
        return Locales.checkNorthAmerica(this.model.user.country);
    }

    addFilterChangeListener() {
        this.view.onEventsFilterChange((location, eventsType) => {
            this.setFilter(location, eventsType);
            this.renderEvents(eventsType);
        });
    }

    addCategoryChangeListener() {
        this.view.onCategoryChange((category) => {
            const eventsType = 'recent';

            this.filters[eventsType].category = category;
            this.renderEvents(eventsType);
        });
    }

    renderEvents(eventsType) {
        switch (eventsType) {
            case 'upcoming':
                this.view.renderEvents(this.model.getUpcomingEvents(this.filters[eventsType]), 'upcoming');
                break;
            case 'recent':
                this.view.renderEvents(this.model.getRecentEvents(this.filters[eventsType]), 'recent');
                break;
        }
    }

    setFilter(location, eventsType) {
        this.filters[eventsType].maxVisibleEvents = this.numberEventsDisplayed;

        this.filters[eventsType].location = location;
        this.view.renderFilter(location, eventsType);
    }

    addMoreEventsListener() {
        this.view.onMoreEventsBtnClick((eventsType) => {
            this.filters[eventsType].maxVisibleEvents += this.numberEventsDisplayed;
            this.view.showEvents(this.filters[eventsType].maxVisibleEvents, eventsType);
        });
    }

    addEventClickListener() {
        this.view.onEventLinkClick((eventName, eventDetail) => {
            window.dispatchEvent(new CustomEvent(eventName, eventDetail));
        });
    }
}

$(function() {
    const eventsPage = new EventsPage();

    eventsPage.init();

    global.eventsPage = eventsPage;
});



// WEBPACK FOOTER //
// ./assets/js/projects/events/events.js